import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./../assests/llogo.png";
import "./LoginPage.css";
import { useDispatch, useSelector } from "react-redux";
import {
  createAccount,
  createPassword,
  loginUser,
  sendOtp,
  verifyOtp,
} from "../Redux/Slice/Login";
import { useSnackbar } from "notistack";
import StepLogin from "./StepLogin";
import StepPhoneRegister from "./StepPhoneRegister";
import StepOtp from "./StepOtp";
import StepPasswordSetup from "./StepPasswordSetup";
import StepRegister from "./StepRegister";
import ForgotPassword from "./ForgotPassword";

const countries = [
  { name: "UAE", code: "+971", flag: "🇦🇪" },
  { name: "India", code: "+91", flag: "🇮🇳" },
];

const genders = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // ---------- Redux States (Destructured for each async action) ----------
  const {
    sendOtp: {
      loading: sendOtpLoading,
      error: sendOtpError,
      // data: sendOtpData,
    },
    verifyOtp: {
      loading: verifyOtpLoading,
      error: verifyOtpError,
      // data: verifyOtpData,
    },
    createPassword: {
      loading: createPasswordLoading,
      error: createPasswordError,
      // data: createPasswordData,
    },
    createAccount: {
      loading: createAccountLoading,
      error: createAccountError,
      // data: createAccountData,
    },
    loginUser: {
      loading: loginLoading,
      error: loginError,
      //  data: loginData
    },
  } = useSelector((state) => state.login);

  // ---------- Component States ----------
  const [step, setStep] = useState("phone");
  const [selectedCountry] = useState(countries[0]);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);

  const [userName, setUserName] = useState("");
  const [fullName, setFullName] = useState("");
  const [age, setAge] = useState(null);
  const [gender, setGender] = useState("");
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showLogin, setShowLogin] = useState(true);
  const [loginUsername, setLoginUsername] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  // ---------- Auto Snackbar for Errors ----------
  useEffect(() => {
    if (sendOtpError) enqueueSnackbar(sendOtpError, { variant: "error" });
    if (verifyOtpError) enqueueSnackbar(verifyOtpError, { variant: "error" });
    if (createPasswordError)
      enqueueSnackbar(createPasswordError, { variant: "error" });
    if (createAccountError)
      enqueueSnackbar(createAccountError, { variant: "error" });
    if (loginError) enqueueSnackbar(loginError, { variant: "error" });
  }, [
    sendOtpError,
    verifyOtpError,
    createPasswordError,
    createAccountError,
    loginError,
    enqueueSnackbar,
  ]);

  // ---------- OTP Timer ----------
  useEffect(() => {
    let interval;
    if (step === "otp" && timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [step, timer]);

  // ---------- Handlers ----------
  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleSendOtp = async () => {
    if (!userName || !emailId) {
      enqueueSnackbar("Please enter both User Name and Email ID", {
        variant: "warning",
      });
      return;
    }

    const result = await dispatch(sendOtp({ emailId, userName }));
    // console.log("result", result);
    if (result?.payload?.status) {
      enqueueSnackbar("OTP sent successfully", { variant: "success" });
      setStep("otp");
    }
  };

  const resendOtp = async () => {
    const result = await dispatch(sendOtp({ emailId, userName }));
    if (result?.payload?.status) {
      enqueueSnackbar("OTP resent successfully", { variant: "info" });
      setTimer(60);
    }
  };

  const handleVerify = async () => {
    const result = await dispatch(verifyOtp({ emailId, otp: otp.join("") }));
    if (result?.payload?.status) {
      enqueueSnackbar("OTP verified successfully", { variant: "success" });
      setStep("passwordSetup");
    } else {
      setOtp(["", "", "", "", "", ""]);
      setTimer(60);
    }
  };

  const handlePasswordSetup = async () => {
    if (!password || !confirmPassword) {
      enqueueSnackbar("Please enter both password fields", {
        variant: "warning",
      });
      return;
    }
    if (password !== confirmPassword) {
      enqueueSnackbar("Passwords do not match", { variant: "error" });
      return;
    }

    const result = await dispatch(
      createPassword({ emailId, password, confirmPassword })
    );
    if (result?.payload?.status) {
      enqueueSnackbar("Password set successfully", { variant: "success" });
      setStep("register");
    }
  };

  const handleCreateAccount = async () => {
    const userDetails = {
      fullName,
      age: parseInt(age, 10),
      gender,
      mobileNo: `${selectedCountry.code} ${mobile}`,
      emailId,
    };

    const result = await dispatch(createAccount(userDetails));
    if (result?.payload?.status) {
      localStorage.setItem("token", result?.payload?.data?.token);
      localStorage.setItem("userInfo", JSON.stringify(result?.payload?.data?.user));
      enqueueSnackbar("Account created successfully", { variant: "success" });
      navigate("/user");
    }
  };

  const handleLogin = async () => {
    if (!loginUsername || !loginPassword) {
      enqueueSnackbar("Please enter both Username and Password", {
        variant: "warning",
      });
      return;
    }

    const result = await dispatch(
      loginUser({ userName: loginUsername, password: loginPassword })
    );
    console.log("resulet", result);
    if (result?.payload.status) {
      localStorage.setItem("token", result?.payload.data?.token);
      localStorage.setItem(
        "userInfo",
        JSON.stringify(result?.payload.data?.user)
      );
      enqueueSnackbar("Login successful", { variant: "success" });
      navigate("/user");
    }
  };

  // ---------- JSX ----------
  return (
    <div
      className="login-page"
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #0e102d, #70c3d2)",
      }}
    >
      {/* Left panel */}
      <div className="left-panel" style={{ color: "white" }}>
        <img
          src={logo}
          alt="Trust Doc Logo"
          style={{
            height: "70px",
            objectFit: "contain",
            cursor: "pointer",
            marginRight: "auto",
          }}
          onClick={() => navigate("/")}
        />
        <h1 style={{ marginTop: "2rem" }}>
          We offer certified and experienced doctors
        </h1>
        <ul style={{ marginTop: "1.5rem", listStyle: "none", paddingLeft: 0 }}>
          <li style={{ marginBottom: "1rem" }}>
            ✅ <strong>1000+</strong> Verified doctors in GCC countries
          </li>
          <li style={{ marginBottom: "1rem" }}>
            ✅ Consult with Doctors across <strong>36+ Specialities</strong>
          </li>
          <li style={{ marginBottom: "1rem" }}>
            ✅ <strong>100%</strong> Private and confidential
          </li>
        </ul>
        <footer style={{ marginTop: "auto" }}>
          © 2023 TrustDoc All Rights Reserved.
        </footer>
      </div>

      {/* Right panel */}
      <div className="right-panel">
        <div className="form-card" style={{ width: "100%", maxWidth: "400px" }}>
          {step === "phone" && showLogin && (
            <StepLogin
              loginUsername={loginUsername}
              loginPassword={loginPassword}
              setLoginUsername={setLoginUsername}
              setLoginPassword={setLoginPassword}
              handleLogin={handleLogin}
              setShowLogin={setShowLogin}
              setStep={setStep}
              loading={loginLoading}
            />
          )}

          {step === "forgotEmail" && showLogin && (
            <ForgotPassword setStep={setStep} />
          )}

          {step === "phone" && !showLogin && (
            <StepPhoneRegister
              userName={userName}
              emailId={emailId}
              setUserName={setUserName}
              setEmailId={setEmailId}
              handleSendOtp={handleSendOtp}
              setShowLogin={setShowLogin}
              loading={sendOtpLoading}
            />
          )}

          {step === "otp" && (
            <StepOtp
              otp={otp}
              timer={timer}
              handleOtpChange={handleOtpChange}
              resendOtp={resendOtp}
              handleVerify={handleVerify}
              loading={verifyOtpLoading}
            />
          )}

          {step === "passwordSetup" && (
            <StepPasswordSetup
              password={password}
              confirmPassword={confirmPassword}
              setPassword={setPassword}
              setConfirmPassword={setConfirmPassword}
              handlePasswordSetup={handlePasswordSetup}
              loading={createPasswordLoading}
            />
          )}

          {step === "register" && (
            <StepRegister
              fullName={fullName}
              age={age}
              gender={gender}
              mobile={mobile}
              emailId={emailId}
              genders={genders}
              setFullName={setFullName}
              setAge={setAge}
              setGender={setGender}
              setMobile={setMobile}
              setEmailId={setEmailId}
              handleCreateAccount={handleCreateAccount}
              loading={createAccountLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
